let initialUrl: string = "";

export function setInitialUrl() {
    initialUrl = window.location.href;
}

export function getInitialUrl(): string {
    return initialUrl;
}
